/**
 * The app shell on fixture data (parity card `P-002`).
 *
 * `/__ui/board` mounts the **product's** `<AppShell/>` — same top bar, same 72 px rail, same
 * 279 px pane, same board header — with `modules/shell/demo.tsx` answering the three shell
 * queries. Nothing about the shell is re-implemented here; if it drifts, the fixture drifts
 * with it, which is the point of a screen fixture.
 */
import { AppShell } from '../../app/AppShell';
import { DemoShellProvider } from '../../modules/shell/demo';

export function DemoShell() {
  return (
    <DemoShellProvider>
      <AppShell />
    </DemoShellProvider>
  );
}
